unit UHelper;

interface

uses
  System.SysUtils,
  WEBLib.WebTools,
  Web,
  WEBLib.JSON,
  JS,
  XData.Web.Client,
  Bcl.Utils,
  WEBLib.RegularExpressions,
  UErrorHandling,
  UResources;

type

  THelper = class
  public
    class function GetErrors(AResponse:TXDataClientResponse): TErrors;
    class procedure DebugODS(const Msg : string);
    class function DateFormat(ADateStr: string; AFormat: string = sDateFormat): string;
    class function DateTimeFormat(ADateTimeStr: string; AFormat: string = sDateTimeFormat): string;
    class function ISODateTimeFormat(ADateTimeStr:string; AFormat: string = sServerDateTimeFormat): string;
    class function IsEmailValid(AEmail: String): Boolean;
  end;

implementation
//{
//"error" : {
//    "code": 400,   <- does not work
//    "message": "an error"
//  }
//}

class function THelper.GetErrors(AResponse:TXDataClientResponse): TErrors;
var
  lErrorObject, lErrorValues: TJSONObject;
//  lvalue: TJSONArray;
begin
  Result:= TErrors.Create;
  Result.handled := false;

  lErrorObject := TJSONObject.ParseJSONValue(AResponse.ResponseText) as TJSONObject;

  lErrorValues := lErrorObject.GetValue('error') as TJSONObject;

  if lErrorValues.Count <> 0 then
  begin
    Result.code:= StrToInt(lErrorValues.GetValue('code').Value);
    Result.errorMessage := lErrorValues.GetValue('error').Value;
    Result.handled := true;
  end;
end;

class function THelper.IsEmailValid(AEmail: String): Boolean;
const
  CPattern = '^\w+([\.-]?\w+)*@\w+([\.-]?w+)*(\.\w{2,3})+$';
begin
  Result := TRegEx.IsMatch(AEmail, CPattern);
end;

class function THelper.ISODateTimeFormat(ADateTimeStr:string; AFormat: string): string;
var
  lDateValue: TDateTime;
begin
  // '2021-05-22T13:57:49.191' accepted value
  // '2021-05-22T13:57:49.19134Z' not accepted
  if length(ADateTimeStr) = 19 then
  begin
    ADateTimeStr := ADateTimeStr + sMilliSecondsinit;
  end
  else if length(ADateTImeStr) > 23 then
  begin
    ADateTimeStr := ADateTimeStr.Substring(0, 23)
  end;

  if TBclUtils.TryISOToDateTime(ADateTimeStr, lDateValue) then
  begin
    Result := FormatDateTime(AFormat, lDateValue);
    DebugODS(Result);
  end
  else
  begin
    DebugODS(sInvalidDate);
  end;
end;

class function THelper.DateFormat(ADateStr, AFormat: String): String;
var
  lCustomFormatSettings: TFormatSettings;
  lDateValue: TDateTime;
begin
 lCustomFormatSettings := TFormatSettings.Create;
 lCustomFormatSettings.ShortDateFormat := sServerDate;
 lCustomFormatSettings.DateSeparator := sDashSeparator;
  if TryStrToDate(ADateStr, lDateValue, lCustomFormatSettings) then
  begin
    Result := FormatDateTime(AFormat, lDateValue);
    DebugODS(Result);
  end
  else
  begin
    DebugODS(sInvalidDate);
  end;
end;

class function THelper.DateTimeFormat(ADateTimeStr, AFormat: string): string;
var
  lCustomFormatSettings: TFormatSettings;
  lDateTimeValue: TDateTime;
begin
 lCustomFormatSettings := TFormatSettings.Create;
 lCustomFormatSettings.ShortDateFormat := sServerDate;
 lCustomFormatSettings.DateSeparator := sDashSeparator;
  if TryStrToDateTime(ADateTimeStr, lDateTimeValue, lCustomFormatSettings) then
  begin
    Result := FormatDateTime(AFormat, lDateTimeValue);
    DebugODS(Result);
  end
  else
  begin
    DebugODS(sInvalidDate);
  end;
end;


class procedure THelper.DebugODS(const Msg : string);
begin
  {$IFDEF DEBUG}
  OutputDebugString(DateTimeToStr(now) + ' : ' + Msg + sLineBreak);
  {$ENDIF}
end;

end.
